var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"grupo-conceito","rota-base":"/admin/grupo-conceito","titulo":"GRUPOS DE CONCEITO","titulo-singular":"Grupo de Conceito","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }